export default class BookingPopup {
    constructor() {
        this.popup = document.querySelector('[data-id="booking-popup"]');
        this.popupOpen = document.querySelectorAll('[data-id="open-booking-popup"]');
        this.popupClose = document.querySelectorAll('[data-id="close-booking-popup"]');
        if (!this.popup || !this.popupOpen || !this.popupClose) {
            return;
        }
        this.init();
    }

    init() {
        this.popupOpen.forEach((opener) => {
            opener.addEventListener('click', (e) => {
                this.popup.classList.remove('hidden');
                this.popup.classList.add('flex');
                this.popup.classList.add('is-visible');
            });
        });

        this.popupClose.forEach((closer) => {
            closer.addEventListener('click', (e) => {
                this.popup.classList.remove('is-visible');
                setTimeout(() => {
                    this.popup.classList.remove('flex');
                    this.popup.classList.add('hidden');
                }, 500);
            });
        });
    }
};
